export default __webpack_public_path__ + "static/Homing_Underwater_Mine-af83611a4410b9a1d6a18f9e59d90744.png";